export default {"seoOptimise":true,"resolveAliases":true,"ogTitleTemplate":"%s | ByteDream","ogDescriptionTemplate":"%s"}